import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './i18n';
import { CompareProvider } from './context/CompareContext';
import './index.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <CompareProvider>
          <App />
        </CompareProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
);